const customImageLoader = ({ src }) => src

export default customImageLoader
